import { useState, useEffect } from 'react';
import api from '../utils/axios';
import { mapCustomToEstado } from '../lib/caseStatusMeta';

// Devuelve los estados personalizados activos, ya mapeados a {value,label,color,icon}.
export function useCustomCaseStatuses() {
  const [customEstados, setCustomEstados] = useState([]);
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const r = await api.get('/case-statuses', { skipAuthRedirect: true });
        if (active) setCustomEstados((r.data?.statuses || []).map(mapCustomToEstado));
      } catch { /* sin personalizados */ }
    })();
    return () => { active = false; };
  }, []);
  return customEstados;
}
